import { forwardRef, ChangeEvent } from 'react';
import { 
	SliderContainer, 
	SliderValue, 
	SliderLabel, 
	SliderHeader, 
	StyledRangeInput
} from './Slider.style';

// Constants to avoid magic numbers
const DEFAULT_MIN = 0;
const DEFAULT_MAX = 100;
const DEFAULT_STEP = 1;
const DEFAULT_SIZE = 12; // Default size in pixels

interface SliderProps {
  value: number;
  onChange: (value: number, event: ChangeEvent<HTMLInputElement>) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  size?: number; // Size in pixels
  label?: string;
  hideValue?: boolean;
  ariaLabel?: string;
  name?: string;
  id?: string;
  className?: string;
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(({
	value,
	onChange,
	min = DEFAULT_MIN,
	max = DEFAULT_MAX,
	step = DEFAULT_STEP,
	disabled = false,
	size = DEFAULT_SIZE,
	label,
	hideValue = false,
	ariaLabel,
	name,
	id,
	className
}, ref) => {
	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(Number(e.target.value), e);
	};

	// Calculate fill percentage for background
	const fillPercentage = ((value - min) / (max - min)) * 100;

	return (
		<SliderContainer className={className}>
			{(label || !hideValue) && (
				<SliderHeader>
					{label && <SliderLabel htmlFor={id}>{label}</SliderLabel>}
					{!hideValue && <SliderValue>{value}</SliderValue>}
				</SliderHeader>
			)}
			<StyledRangeInput
				ref={ref}
				type="range"
				value={value}
				min={min}
				max={max}
				step={step}
				disabled={disabled}
				onChange={handleChange}
				$size={size}
				$fillPercentage={fillPercentage}
				aria-label={ariaLabel || label}
				name={name}
				id={id}
			/>
		</SliderContainer>
	);
});

Slider.displayName = 'Slider';
